import { Box, SwipeableDrawer as MuiSwipeableDrawer, SxProps } from '@mui/material'
import useDrawerBackBehavior from './useDrawerBackBehavior'

/**
 * For back navigation to work properly, ensure this component always mounts from the parent. Control its visibility using the open prop, and render its children conditionally as needed.
 */

const SwipeableDrawerWithBackNavigation = ({
    open,
    anchor = 'bottom',
    disableSwipeToOpen = false,
    onClose,
    onOpen = () => {},
    children,
    enableBackNavigation = true,
    isLoginFlow = false,
    sx = {}
}: {
    open: boolean
    anchor?: 'bottom' | 'top' | 'left' | 'right'
    disableSwipeToOpen?: boolean
    onOpen?: () => void
    onClose: () => void
    children: React.ReactNode
    enableBackNavigation?: boolean
    isLoginFlow?: boolean
    sx?: SxProps
}) => {
    const { markHistoryForOpen, closeAndGoBack } = useDrawerBackBehavior({
        isOpen: open,
        onClose
    })

    // Handle opening with history management (for swipe-to-open)
    const handleOpen = () => {
        if (enableBackNavigation) {
            markHistoryForOpen()
        }
        onOpen()
    }

    // Use either back-aware close or regular close
    const handleClose = enableBackNavigation ? closeAndGoBack : onClose

    return (
        <MuiSwipeableDrawer
            anchor={anchor}
            open={open}
            onClose={handleClose}
            onOpen={handleOpen}
            slotProps={{
                paper: {
                    sx: {
                        borderTopLeftRadius: '16px',
                        borderTopRightRadius: '16px',
                        height: '90dvh',
                        maxHeight: '90dvh',
                        display: 'flex',
                        flexDirection: 'column',
                        ...sx
                    }
                }
            }}
            disableSwipeToOpen={disableSwipeToOpen}
        >
            {!isLoginFlow && (
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pt: 1, pb: 1 }}>
                    <Box sx={{ width: 40, height: 5, bgcolor: '#e0e0e0', borderRadius: 3 }} />
                </Box>
            )}

            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>{children}</Box>
        </MuiSwipeableDrawer>
    )
}

export default SwipeableDrawerWithBackNavigation
